import StarRating from './StarRating';
export { default as StarRatingDisplay } from './StarRatingDisplay';
export { default as StarIcon } from './StarIcon';
export default StarRating;
//# sourceMappingURL=index.js.map